module.exports = __webpack_public_path__ + "img/mat_405.471000ca.png";